/* MITMIT — Dawn behaviors: header logo scroll-swap. */
(function(){
  // 1. Header logo swaps to the dino mark once you scroll past the hero.
  function initLogoSwap(){
    var logo=document.querySelector('.header__heading-logo');
    if(!logo||!window.MITMIT_MARK)return;
    var orig=logo.currentSrc||logo.src, origSrcset=logo.getAttribute('srcset'), swapped=false;
    function set(toMark){
      if(toMark===swapped)return;swapped=toMark;
      logo.style.opacity='0';
      setTimeout(function(){
        if(toMark){logo.removeAttribute('srcset');logo.src=window.MITMIT_MARK;}
        else{logo.src=orig;if(origSrcset)logo.setAttribute('srcset',origSrcset);}
        logo.style.opacity='1';
      },200);
    }
    window.addEventListener('scroll',function(){set(window.scrollY>window.innerHeight*0.5);},{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initLogoSwap);
  else initLogoSwap();
})();
